<template>
  <div>
    <Card>
      <Row>
        <!-- <Button type="info"
                @click="add">新增</Button> -->
      </Row>
      <TablePaginate :columns="columns"
                     :data="ais"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <!-- @on-ok="handleSubmit" -->
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_ai_image_157')">
      <Form ref="category"
            disabled
            :model="ai"
            :label-width="80">
        <Form-item :label="$t('pages_ai_image_158')"
                   prop="name">
          <Input type="text"
                 v-model="ai.name" />
        </Form-item>
        <Form-item :label="$t('pages_ai_index_164')"
                   prop="alias_name">
          <Input type="text"
                 v-model="ai.alias_name" />
        </Form-item>
        <Form-item :label="$t('pages_ai_image_159')"
                   prop="env">
          <Input type="text"
                 v-model="ai.env" />
        </Form-item>
        <Form-item :label="$t('pages_ai_image_160')"
                   prop="store_id">
          <Input type="text"
                 v-model="ai.store_id" />
        </Form-item>

      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: i18n.t('pages_ai_image_158'),
          key: 'name'
        },
        {
          title: i18n.t('pages_ai_index_164'),
          key: 'alias_name'
        },
        {
          title: i18n.t('pages_ai_image_161'),
          key: 'store_id'
        },
        {
          title: i18n.t('pages_ai_image_162'),
          key: 'env'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 300,
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapState('ai', ['ai', 'ais', 'meta', 'loading']),
  },
  methods: {
    ...mapActions('ai', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('ai', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.ai)
      } else if (this.formType === 'new') {
        await this.create(this.ai)
      }
      this.modalShow = false
    },
  }
}
</script>
